"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceLineType = void 0;
/**
 * @deprecated use OfferSubType
 */
var ServiceLineType;
(function (ServiceLineType) {
    ServiceLineType["UNKNOWN"] = "UNKNOWN";
    ServiceLineType["HEALTH"] = "HEALTH";
    ServiceLineType["VETERINARIAN"] = "VETERINARIAN";
    ServiceLineType["VACCINATIONS"] = "VACCINATIONS";
    ServiceLineType["GENERAL_CHECKUP"] = "GENERAL_CHECKUP";
    ServiceLineType["EMERGENCY_CARE"] = "EMERGENCY_CARE";
    ServiceLineType["SURGICAL_CARE"] = "SURGICAL_CARE";
    ServiceLineType["NUTRITION"] = "NUTRITION";
    ServiceLineType["PHARMACY"] = "PHARMACY";
    ServiceLineType["SPECIALIST_CARE"] = "SPECIALIST_CARE";
    ServiceLineType["SPECIALIST_SKIN_CARE"] = "SPECIALIST_SKIN_CARE";
    ServiceLineType["SPECIALIST_HAIR_CARE"] = "SPECIALIST_HAIR_CARE";
    ServiceLineType["SPECIALIST_EYE_CARE"] = "SPECIALIST_EYE_CARE";
    ServiceLineType["SPECIALIST_DIGESTIVE_CARE"] = "SPECIALIST_DIGESTIVE_CARE";
    ServiceLineType["SPECIALIST_DENTAL_CARE"] = "SPECIALIST_DENTAL_CARE";
    ServiceLineType["TRAINING"] = "TRAINING";
    ServiceLineType["BEHAVIOR"] = "BEHAVIOR";
    ServiceLineType["PUPPY_TRAINING"] = "PUPPY_TRAINING";
    ServiceLineType["OBEDIENCE_I"] = "OBEDIENCE_I";
    ServiceLineType["FOUNDATION_SKILLS"] = "FOUNDATION_SKILLS";
    ServiceLineType["SKILL_BUILDING"] = "SKILL_BUILDING";
    ServiceLineType["RELIABILITY"] = "RELIABILITY";
    ServiceLineType["ADVANCED_SKILLS"] = "ADVANCED_SKILLS";
    ServiceLineType["EXPERT_SKILLS"] = "EXPERT_SKILLS";
    ServiceLineType["SPORT"] = "SPORT";
    ServiceLineType["AGILITY_TRAINING"] = "AGILITY_TRAINING";
    ServiceLineType["HUNTING_TRAINING"] = "HUNTING_TRAINING";
    ServiceLineType["GUARD_TRAINING"] = "GUARD_TRAINING";
    ServiceLineType["GROOMING"] = "GROOMING";
    ServiceLineType["HAIR"] = "HAIR";
    ServiceLineType["NAILS"] = "NAILS";
    ServiceLineType["EAR"] = "EAR";
    ServiceLineType["SKIN"] = "SKIN";
    ServiceLineType["SOCIAL"] = "SOCIAL";
    ServiceLineType["SOCIAL_SUPPORT"] = "SOCIAL_SUPPORT";
    ServiceLineType["DOG_WALKERS"] = "DOG_WALKERS";
    ServiceLineType["DAYCARE"] = "DAYCARE";
    ServiceLineType["DOG_SITTER"] = "DOG_SITTER";
    ServiceLineType["BOARDING"] = "BOARDING";
    ServiceLineType["DROP_IN_VISITS"] = "DROP_IN_VISITS";
    ServiceLineType["ADOPTION_SERVICES"] = "ADOPTION_SERVICES";
    ServiceLineType["SOCIAL_RECREATIONAL"] = "SOCIAL_RECREATIONAL";
    ServiceLineType["DOG_MEET_UP"] = "DOG_MEET_UP";
    ServiceLineType["DOG_PLAY_GROUPS"] = "DOG_PLAY_GROUPS";
    ServiceLineType["ADULT_PLAY_GROUPS"] = "ADULT_PLAY_GROUPS";
    ServiceLineType["PUPPY_PLAY_GROUPS"] = "PUPPY_PLAY_GROUPS";
    ServiceLineType["RECREATIONAL_DOG_PARKS"] = "RECREATIONAL_DOG_PARKS";
    ServiceLineType["SMALL_DOG_PARKS"] = "SMALL_DOG_PARKS";
    ServiceLineType["DOG_PARKS"] = "DOG_PARKS";
    ServiceLineType["PUPPY_PARKS"] = "PUPPY_PARKS";
})(ServiceLineType = exports.ServiceLineType || (exports.ServiceLineType = {}));
